export default "/images/tryg.webp?ef60d40db0be282d58d4ac54bfc3dda2";